export default __webpack_public_path__ + "static/media/return-item-icon.68492784.svg";